import React, { useState, useEffect } from "react";
import { Input } from "@fragments";

export default function Description({ value, onInput }) {
    const [_value, setValue] = useState(value);

    useEffect(() => {
        onInput(_value);
    }, [_value]);

    return (
        <Input.Text
            multiline={true}
            size={1000}
            value={_value}
            label="Descrição (opcional)"
            placeholder="Descrição (opcional)"
            onInput={setValue}
            emoji
        />
    );
}
